<div class="auth-callback-container" *ngIf="!showConsentGate">
  <mat-spinner></mat-spinner>
  <p>Completing login...</p>
</div>

<!-- Consent gate for accounts Google created before the user agreed (see component). -->
<div class="consent-gate" *ngIf="showConsentGate">
  <div class="consent-card">
    <img src="assets/images/logos/studioip logo black.png" alt="StudioIP" class="consent-logo" />
    <h2 class="consent-title">One last step</h2>
    <p class="consent-lede">
      Your account has been created. Please review and accept the Terms of Use and
      Privacy Policy to continue to StudioIP.
    </p>

    <label class="consent-row">
      <input type="checkbox" class="consent-checkbox" [(ngModel)]="agreedToTerms" />
      <span class="consent-text">
        I agree to the
        <a class="consent-link" href="#" (click)="legalModal = 'terms'; $event.preventDefault()">Terms of Use</a>
        and the
        <a class="consent-link" href="#" (click)="legalModal = 'privacy'; $event.preventDefault()">Privacy Policy</a>
      </span>
    </label>

    <p class="consent-error" *ngIf="consentError">{{ consentError }}</p>

    <button type="button" class="consent-btn-primary" [disabled]="!agreedToTerms || isSubmitting" (click)="submitConsent()">
      <span *ngIf="!isSubmitting">Agree and continue</span>
      <mat-spinner *ngIf="isSubmitting" diameter="18"></mat-spinner>
    </button>
    <button type="button" class="consent-btn-secondary" [disabled]="isSubmitting" (click)="declineConsent()">
      Cancel
    </button>
  </div>
</div>

<app-legal-modal
  *ngIf="legalModal"
  [doc]="legalModal"
  (closed)="legalModal = null"
  (agreed)="agreeFromModal()">
</app-legal-modal>
